import { FormControl, FormGroup, Validators } from '@angular/forms';

export class TradeSpecialtyCategoryForm extends FormGroup<{
  id: FormControl<number | undefined>;
  PrimaryTradeId: FormControl<number | undefined>;
  TradeCategoryId: FormControl<number | undefined>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      PrimaryTradeId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TradeCategoryId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }
}
